import { useState } from 'react';
import ButtonFileUpload from '../../../../../components/molecules/ButtonFileUpload/ButtonFileUpload';
import hsCodeTemplate from '../../../../../assets/hscode.xlsx';

interface HsCodeFormProps {
  onChange: (file: string) => void;
}

const HsCodeForm = ({ onChange }: HsCodeFormProps) => {
  const [hasFile, setHasFile] = useState(false);

  return (
    <div className={'flex gap-3 items-center'}>
      <ButtonFileUpload
        accept=".xlsx"
        label={'Cargar archivo'}
        base64
        onSubmit={(e) => {
          if (typeof e === 'string') {
            setHasFile(e !== '');
            onChange(e);
          }
        }}
      />
      {!hasFile && (
        <div className="text-xs mt-1.5">
          <a
            className="text-blue-600 hover:underline"
            href={hsCodeTemplate}
            download={'hscode.xlsx'}
          >
            Descargar plantilla
          </a>
        </div>
      )}
    </div>
  );
};

export default HsCodeForm;
